// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';

/** @typedef {{
  size?: number
}} MapPinPropsType */

/** @type { React.ValidationMap<MapPinPropsType> } */
const propTypes = {
  size: PropTypes.number,
};

/**
 * This component styling just deals with how the MapPin looks.
 * For positioning, look to whatever component this wrapped in.
 *
 * @type { StatelessComponent<MapPinPropsType> }
 */
const MapPin = ({ size }) => {
  const width = size;
  const height = (width / 30) * 42; // orig size: 30px x 42px

  return (
    <div className="MapPin">
      <img src="/assets/map_pin.png" alt="map_pin_icon" width={width} height={height} />
    </div>
  );
};

MapPin.displayName = 'MapPin';
MapPin.propTypes = propTypes;

MapPin.defaultProps = {
  size: 30,
};

export default MapPin;
